// 零售批发模块路由配置
// 包含三个角色：客户端、零售店端、批发商端

export default [
  // ==================== 客户端路由 ====================
  {
    path: '/customer-home', // 客户首页
    name: 'CustomerHome',
    meta: {
      navBarFlag: false,
      tabBarFlag: true, // 显示底部TabBar
      requiredAuth: true,
      title: '客户首页 - 小炮庄'
    },
    component: () => import('@pages/retailWholesale/customer/customerHome')
  },
  {
    path: '/customer-order', // 客户订单
    name: 'CustomerOrder',
    meta: {
      navBarFlag: false,
      tabBarFlag: true, // 显示底部TabBar
      requiredAuth: true,
      title: '我的订单 - 小炮庄'
    },
    component: () => import('@pages/retailWholesale/customer/customerOrder')
  },

  // ==================== 零售店端路由 ====================
  {
    path: '/retail-shop-home', // 零售店首页
    name: 'RetailShopHome',
    meta: {
      navBarFlag: false,
      tabBarFlag: false,
      requiredAuth: true,
      title: '零售店首页 - 小炮庄'
    },
    component: () => import('@pages/retailWholesale/retailShop/shopHome')
  },

  // ==================== 批发商端路由 ====================
  // TODO: 待添加批发商端路由
];
